import * as Services from "../../../Service/Service";
import * as Url from "../../../Service/Url";

export const GetCommissionRateByGroupSizeZipCode = async (zip, groupSize) => {
  const token = localStorage.getItem("token");
  const url = `${Url.GET_COMMISSIONRATEBYGROUPSIZEZIPCODE}zipCode=${zip}&groupSize=${groupSize}`;
  let res = await Services.GET(url, token);
  return res;
};

export const GetClientsDataByClientID = async (udid, id) => {
  const token = localStorage.getItem("token");
  let url = `/api/Clients/GetClientsDataByClientID?UD_id=${udid}&clientID=${id}`;
  let res = await Services.GET(url, token);
  return res;
};

export const GetBenchmark = async (payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.POST(Url.GET_BENCHMARK, payload, token);
  return res;
};

export const UpdateClientsDetails = async (payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.POST(Url.UPDATE_CLIENT_DETAILS, payload, token);
  return res;
};

// export const DeleteCoci = async (cociId) => {
//   const token = localStorage.getItem("token");
//   const params = { cociId };
//   let res = await Services.DELETE(Url.DELETE_COCI+cociId, params, token);
//   return res;
// };

export const SaveClientDetails = async (payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.PUT(Url.SAVE_CLIENT_DETAILS, payload, token);
  return res;
};

export const GetApprovedRegionsByUDid = async (UD_id) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_APPROVED_REGION_UDID + `UD_id=${UD_id}`, token);
  return res;
};


export const GetClientByClientID = async (id) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GETCLIENTBYCLIENTID + id, token);
  return res;
};


